module.exports = __webpack_public_path__ + "img/logo.f09c9772.png";